import { Link } from 'react-router-dom';

import GmnLogo from '/gmn-logo.svg';

export const Logo = () => (
  <div className="h-16 flex items-center px-6 border-b border-border">
    <Link to="/" className="flex items-center gap-2 group/logo">
      <img src={GmnLogo} alt="GMN Logo" className="w-10 h-10 rounded-md" />
      <div className="flex flex-col group-data-[collapsible=icon]/sidebar:hidden">
        <span className="font-bold text-foreground leading-tight">GMN</span>
        <span className="text-[10px] text-muted-foreground uppercase tracking-wider">Portal</span>
      </div>
    </Link>
  </div>
);
